import { Trans } from "@lingui/macro";
import { UiModuleLoader } from "@smp/ui";
import { lazy, Suspense } from "react";

const Module = lazy(() => import(/* webpackChunkName: "auth" */ "./auth"));

export const Auth = () => (
  <Suspense fallback={<UiModuleLoader loadingText={<Trans>Loading</Trans>} />}>
    <Module />
  </Suspense>
);
